<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Loan details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field appearance="outline">
          <mat-label>Loan purpose</mat-label>
          <mat-select placeholder="Loan purpose" formControlName="purpose">
            <mat-option *ngFor="let purpose of loanPurposes" [value]="purpose.slug">{{purpose.ext.Description}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'purpose'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field appearance="outline">
          <mat-label>Select a product</mat-label>
          <mat-select placeholder="Select a product" formControlName="product" [disabled]="!enableProductList">
            <mat-option *ngFor="let product of productVariations" [value]="product.slug">
              {{product.pricing[0].displayName}}
            </mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'product'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
